import React, { memo, useEffect, useState } from 'react';
import ShareButton from './ShareButton';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import {
  selectAddonsList,
  selectAvailableConfigurator,
  selectHighestPlanOrderId,
  selectUserActivePlanDetails,
  selectUserActivePlanSubscriptionOrderId,
  selectUserPlanList,
} from '../../redux/slicers/subscriptionSlicer';
import { useSelector } from 'react-redux';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { useCopyToClipboard } from 'react-use';
import {
  LINKED_PRODUCT_DATA,
  OFFER_PRICE_DATA,
  navigateToUpgradePlan,
} from '../subscriptionComponents/subscriptionHelper';
import {
  AddAddonCart,
  GetAllCartProductList,
  getSubscriptionLinkedProductData,
  linkSubscriptionProductData,
  removeAllItemsFromCart,
  setClientSubscriptionPlans,
} from '../../api/subscription/subscription';
import { openFormInCaseOfNewOrgAndFreemiumUser, windowOpen } from '../../helpers/jsHelper';
import { dispatcher, navigate } from '../../helpers/projectHelper';
import { ADMIN_SETTINGS, SIGN_IN_ROUTE, SIGNUP_ROUTE } from '../../constants/routePathConstants';
import { useUserContext } from '../../contexts/UserContext';
import modalStyles from '../../components/InfoDialog/InfoDialogUI.module.scss';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { SETTINGS_TAB } from '../../constants/constants';
import { selectPdpProductCountInfo } from '../../redux/slicers/productV2Slicer';
import { isPdpProduct } from '../NewProductUIV2/ShareButtonV2/helpers';

export const ConfiguratorShowCase = memo(
  ({
    productId,
    productInfo,
    isPublicPage,
    productUnicodeId,
    productOrg,
    orgProductUniqueCodeId,
    refetchDetails,
    isPackProduct,
  }) => {
    const { currentUser, isOldSubscriptionUser, isPremiumUser, isGuestUser, isGuestLogin } =
      useUserContext();
    const { isFreemiumUser, isFreemiumOrSelfServeUser, hideNewPlans } =
      useCurrentOrganizationInfo();

    const [checkURL, setCheckURL] = useState(false);
    const [configuratorURL, setConfiguratorURL] = useState(null);

    const [state, copy] = useCopyToClipboard();

    const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();

    const activePlan = useSelector(selectUserActivePlanDetails) || isOldSubscriptionUser();
    const availableConfiguratorCount = useSelector(selectAvailableConfigurator);
    // const highestPlanOrder = useSelector(selectHighestPlanOrderId);
    // const activePlanOrder = useSelector(selectUserActivePlanSubscriptionOrderId);
    const { results: addonsList } = useSelector(selectAddonsList);
    const getUserPlans = useSelector(selectUserPlanList);
    const isOldPremiumUser = isPremiumUser() && getUserPlans?.length === 0;

    // const showUpgradeButton = highestPlanOrder > activePlanOrder;

    const [actionMenu, setActionMenu] = useState([]);

    const pdpProductCountInfo = useSelector(selectPdpProductCountInfo);
    const pdpConfiguratorCount = pdpProductCountInfo?.configurator || 0;

    useEffect(() => {
      setActionMenu([
        {
          id: 1,
          title: 'Disabled',
          icon: null,
          onClick: handleEnabledDisabled,
          type: 'toggle',
          initialValue: false,
        },
        { id: 2, title: 'Copy Link', icon: null, onClick: handleCopy, disabled: true },
        { id: 3, title: 'Embed on website', icon: null, onClick: handleEmbedding, disabled: true },
      ]);
    }, [
      configuratorURL,
      productUnicodeId,
      orgProductUniqueCodeId,
      productInfo?.configurator_status,
      pdpConfiguratorCount,
    ]);

    useEffect(async () => {
      if (!productUnicodeId) return;
      const res = await getSubscriptionLinkedProductData({
        type: LINKED_PRODUCT_DATA.CONFIGURATOR,
        isPublicPage: isPublicPage && !currentUser,
        params: {
          product_uuid: productUnicodeId,
          product_org: productOrg || currentUser?.organization,
          is_preview: isPublicPage && !currentUser,
        },
      });
      if (res && res?.results?.length > 0) {
        setConfiguratorURL(res.results[0].url);
      }
    }, [productUnicodeId]);

    useEffect(() => {
      setActionMenu((prev) => [
        ...prev
          .map((a) => {
            if (a.id === 1 && !isPackProduct) {
              return {
                ...a,
                title: productInfo?.configurator_status || pdpConfiguratorCount ? 'Enabled' : 'Disabled',
                initialValue: productInfo?.configurator_status || pdpConfiguratorCount,
                disabled: pdpConfiguratorCount ? true : false,
              };
            }
            if (a.id === 1 && isPackProduct) return null;
            return {
              ...a,
              disabled: isPackProduct
                ? false
                : productInfo?.configurator_status || pdpConfiguratorCount
                ? false
                : true,
            };
          })
          .filter(Boolean),
      ]);
    }, [
      configuratorURL,
      productUnicodeId,
      orgProductUniqueCodeId,
      productInfo?.configurator_status,
      pdpConfiguratorCount,
      isPackProduct,
    ]);

    async function doEnableDisable(toggleValue) {
      const formData = new FormData();
      formData.append('type', LINKED_PRODUCT_DATA.CONFIGURATOR);
      formData.append('is_link', toggleValue);
      formData.append('product_id', productId);
      const res = await linkSubscriptionProductData(formData);
      if (res?.status) {
        successToast(res?.message);
      } else {
        toggleValue = false;
      }
      dispatcher(setClientSubscriptionPlans());
      refetchDetails?.();

      const updatedMenu = actionMenu.map((a) => {
        if (a.id === 1) {
          return {
            ...a,
            title: toggleValue ? 'Enabled' : 'Disabled',
            initialValue: toggleValue,
          };
        }
        return {
          ...a,
          disabled: !toggleValue,
        };
      });
      setActionMenu(updatedMenu);
    }

    function openModelWhileDisabling(toggleValue) {
      openInfoDialog({
        title: 'Product Configurator',
        description:
          'Are you sure you want to disable Product Configurator? This will disable the public link or embedded link you used.',
        buttonText: 'Yes',
        onButtonClick: () => doEnableDisable(toggleValue),
        cancelButtonText: 'No',
        dialogClassName: modalStyles.viewerModal,
        designV2: true,
        btnContainerClass: 'justify-content-end',
        designV2Props: {
          fillBtnClassName: modalStyles.viewerBtn,
          cancelBtnClassName: modalStyles.cancelBtn,
        },
      });
    }

    function handleEnabledDisabled(item) {
      item.e.stopPropagation();
      let toggleValue = item.value;
      if (toggleValue) doEnableDisable(toggleValue);
      else openModelWhileDisabling(toggleValue);
    }

    function handleCopy() {
      if (!configuratorURL || !orgProductUniqueCodeId) {
        errorToast('Unable to copy. Please try again later.');
        return;
      }
      let url = configuratorURL;
      if (url?.includes('configurator-viewer')) {
        url = url.replace('configurator-viewer', 'configurator-public-viewer');
      }
      copy(`${url}?unicode=${orgProductUniqueCodeId}`);
      successToast('Link Copied');
    }

    function handleEmbedding() {
      if (!configuratorURL || !orgProductUniqueCodeId) {
        errorToast('Unable to copy. Please try again later.');
        return;
      }

      let url = configuratorURL;
      if (url?.includes('configurator-viewer')) {
        url = url.replace('configurator-viewer', 'configurator-public-viewer');
      }
      const embedLink = `${url}?unicode=${orgProductUniqueCodeId}`;
      const iframeCode = `<iframe style="border: none;" src="${embedLink}" title="${productInfo?.name}" width="100%" height="768px" allowfullscreen></iframe>`;
      // const iframeCode = `<div style="width: 100%; position: relative; padding-bottom: 56%;"><iframe style="border: none; bottom: 0; left: 0; position: absolute; height: 100%; right: 0; top: 0;" src="${embedLink}" width="100%"></iframe></div>`;
      copy(iframeCode);
      successToast('Embed Link Copied');
    }

    const preventWindowToScroll = (e) => {
      if (!document.fullscreenElement) {
        // Restore the saved scroll position
        setTimeout(() => {
          const element = document.getElementById(e.target.id);
          element?.scrollIntoView();
        }, 250);
      }
    };

    useEffect(() => {
      if (!productUnicodeId) return;
      const productConfiguratorIframe = document.getElementById('iframe-product-configurator');
      productConfiguratorIframe?.addEventListener('fullscreenchange', preventWindowToScroll);
      return () => {
        productConfiguratorIframe?.removeEventListener('fullscreenchange', preventWindowToScroll);
      };
    }, [productUnicodeId, configuratorURL]);

    // check the URL is valid or not
    const isValidUrl = (urlString) => {
      var inputElement = document.createElement('input');
      inputElement.type = 'url';
      inputElement.value = urlString;
      if (!inputElement?.checkValidity()) {
        checkURL && setCheckURL(false);
      } else {
        !checkURL && setCheckURL(true);
      }
    };

    if (!configuratorURL) {
      checkURL && setCheckURL(false);
      return null;
    } else {
      isValidUrl(configuratorURL);
    }

    const buyConfigurator = async () => {
      await dispatcher(GetAllCartProductList());

      // const response = await apiGetProductConfiguratorDeduct(`configurator=${configuratorId}`)

      const addonsItem = addonsList?.find(
        ({ basemodeltype }) => basemodeltype === OFFER_PRICE_DATA['Configurator'].baseModelType
      );

      let payload = {
        subscription_price: addonsItem?.id || OFFER_PRICE_DATA['Configurator'].product_id,
        quantity: 1,
      };

      await removeAllItemsFromCart();

      const response = await AddAddonCart(payload, 'add');

      if (response?.status) {
        closeInfoDialog();

        let tab = SETTINGS_TAB.ADD_ONS;
        if (isFreemiumOrSelfServeUser) {
          tab = SETTINGS_TAB.PLANS;
        }

        windowOpen(
          `${ADMIN_SETTINGS}?activeTab=${tab}&checkout=true&is_one_time=false&referrer=${window.location.href}`,
          '_blank'
        );
      }
    };

    const handleShowPopup = () => {
      if (isFreemiumUser) {
        openFormInCaseOfNewOrgAndFreemiumUser();
        return;
      } else {
        navigateToUpgradePlan({ browsePlan: true, newTab: true, referrer: window.location.href });
      }
    };

    const handleShareForUse = () => {
      if (isPdpProduct()) {
        if (!pdpConfiguratorCount) {
          openFormInCaseOfNewOrgAndFreemiumUser();
          return;
        }
        return;
      }
      if (hideNewPlans) {
        // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
        openFormInCaseOfNewOrgAndFreemiumUser();
        return;
      }
      let title = 'Add item';
      let description = '';
      let buttonText = '';
      let buttonText2 = '';
      let onButtonClick = null;
      let onButtonClick2 = null;
      if (isOldPremiumUser && availableConfiguratorCount === 0) {
        title = 'Buy add on';
        buttonText = 'Buy';
        description = 'This item will be added on top of your existing subscription (if any).';
        onButtonClick = buyConfigurator;
      } else if (!activePlan && availableConfiguratorCount === 0) {
        buttonText = 'View plans';
        description =
          'You currently do not have an active subscription. Please purchase a subscription plan or buy this item separately.';
        onButtonClick = () => handleShowPopup();
        onButtonClick2 = buyConfigurator;
        buttonText2 = 'Buy item';
        onButtonClick2 = buyConfigurator;
      } else if (availableConfiguratorCount === 0) {
        buttonText = 'Upgrade plan';
        description =
          'You do not have this item. Please upgrade your subscription plan or buy this item separately.';
        onButtonClick = () => handleShowPopup();
        buttonText2 = 'Buy item';
        onButtonClick2 = buyConfigurator;
      } else {
        return null;
      }

      openInfoDialog({
        title: title,
        description: description,
        buttonText: buttonText,
        onButtonClick: onButtonClick,
        buttonText2: buttonText2,
        onButtonClick2: onButtonClick2,
        addOrSeparator: false,
        btnContainerClass: 'align-items-center',
        designV2: true,
        closeable: false,
        designV2Props: {
          fillBtnClassName: modalStyles.fillBtn,
          okBtnClassName: modalStyles.btnLink,
        },
      });
    };

    if (!checkURL) {
      return null;
    }

    return (
      <>
        <div className="life-style-header">
          <h6 className="main-title">Product Configurator</h6>
          {isGuestUser() || isGuestLogin ? null : (
            <ShareButton
              className="share_button"
              onClick={
                isPublicPage && !currentUser
                  ? () => navigate(SIGN_IN_ROUTE) // SIGNUP_ROUTE // Commenting this code to prevent signup
                  : productInfo?.configurator_status || pdpConfiguratorCount
                  ? null
                  : (!activePlan && availableConfiguratorCount === 0) ||
                    availableConfiguratorCount === 0
                  ? isPackProduct
                    ? null
                    : handleShareForUse
                  : null
              }
              menu={actionMenu}
            />
          )}
        </div>
        <div className="configurator-showcase">
          <iframe
            id="iframe-product-configurator"
            width="100%"
            title={'Product Configurator'}
            src={`${configuratorURL}#toolbar=0`}
            allowFullScreen
          />
        </div>
      </>
    );
  }
);
